export default "__VITE_ASSET__CXQ6aXrB__"